import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Collapse Tile Component');

    const listeners: Array<[Element | Window, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount

        .then(() => {
            mountCollapseTile(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Collapse Tile Component', error);
        });

    return function destroyCollapseTile() {
        unMountCollapseTile(listeners);

        app.logger.debug('[DXA] Collapse Tile Component destroyed');
    };
};

function mountCollapseTile(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const collapseTiles = rootNode.querySelectorAll<HTMLElement>('.collapse-tile-navigation');

    collapseTiles.forEach((tile) => {
        const readButton = tile.querySelector<HTMLElement>('.read-button');
        const closeButton = tile.querySelector<HTMLElement>('.close-button');

        // Called on collapse toggle
        const showToggleMenuButtons = () => {
            readButton?.classList.add('hidden');
            closeButton?.classList.remove('hidden');
        };

        // Called on collapse toggle
        const hideToggleMenuButtons = () => {
            readButton?.classList.remove('hidden');
            closeButton?.classList.add('hidden');
        };

        readButton?.addEventListener('click', showToggleMenuButtons)
        closeButton?.addEventListener('click', hideToggleMenuButtons)
    });
}

function unMountCollapseTile(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
